var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarrotRx = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 27,
    viewBox: "0 0 227 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.02083 13.2333V13.1498C0.02083 5.92753 5.14539 0.0203247 12.4364 0.0203247C16.8735 0.0203247 19.5608 1.64846 21.8523 3.98629L19.1442 7.2843C17.2277 5.40569 15.1653 4.13241 12.3948 4.13241C7.79099 4.13241 4.45795 8.11925 4.45795 13.0871V13.1498C4.45795 18.1177 7.79099 22.188 12.3948 22.188C15.3528 22.188 17.2485 20.9147 19.3108 18.89L22.0189 21.7914C19.4983 24.5467 16.7485 26.3001 12.2489 26.3001C5.22871 26.3001 0 20.539 0 13.2333",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7671 5.61437L30.622 25.8617H26.2891L36.8715 0.270752H40.7878L51.3702 25.8617H46.8914L38.7463 5.61437H38.7671Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9958 13.0672C71.0164 13.0672 72.9537 11.3973 72.9537 8.8299V8.74641C72.9537 6.03285 71.0997 4.52996 67.975 4.52996H61.8297V13.0672H68.0167H67.9958ZM57.5801 0.480499H68.3083C71.3289 0.480499 73.7037 1.41981 75.2452 3.02707C76.5159 4.40472 77.245 6.28333 77.245 8.49592V8.55855C77.245 12.7332 74.8702 15.2381 71.4955 16.2609L77.995 25.8836H73.0162L67.1001 17.0332H61.8089V25.8836H57.5801V0.480499Z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5115 13.0672C99.532 13.0672 101.469 11.3973 101.469 8.8299V8.74641C101.469 6.03285 99.6154 4.52996 96.4906 4.52996H90.3453V13.0672H96.5323H96.5115ZM86.0957 0.480499H96.8239C99.8445 0.480499 102.219 1.41981 103.761 3.02707C105.032 4.40472 105.761 6.28333 105.761 8.49592V8.55855C105.761 12.7332 103.386 15.2381 100.011 16.2609L106.511 25.8836H101.532L95.6157 17.0332H90.3245V25.8836H86.0957V0.480499Z",
    fill: "#141414"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.677 13.2338V13.1503C132.677 8.22416 129.281 4.11208 124.49 4.11208C119.699 4.11208 116.366 8.14067 116.366 13.0668V13.1294C116.366 18.0765 119.761 22.1677 124.552 22.1677C129.344 22.1677 132.677 18.1391 132.677 13.2129M111.949 13.2129V13.1294C111.949 5.9907 117.178 0 124.573 0C131.968 0 137.114 5.9072 137.114 13.0668V13.1294C137.114 20.2891 131.885 26.2589 124.49 26.2589C117.095 26.2589 111.949 20.3517 111.949 13.1921",
    fill: "#141414"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.486 4.61345H142.861V0.480499H162.401V4.61345H154.777V25.8836H150.506V4.61345H150.486Z",
    fill: "#141414"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M181.004 26.0499V1.02255H191.503C194.565 1.02255 197.044 1.98273 198.544 3.48562C199.731 4.67541 200.44 6.34529 200.44 8.14042V8.20304C200.44 12.3777 197.336 14.7782 193.128 15.3627L201.377 26.0499H199.023L191.066 15.6758H182.9V26.0499H181.046H181.004ZM182.858 14.0059H191.274C195.44 14.0059 198.565 11.8976 198.565 8.28653V8.22391C198.565 4.86328 195.919 2.75505 191.399 2.75505H182.858V14.0267V14.0059ZM204.898 26.0499L214.813 13.2753L205.252 1.00168H207.46L215.98 12.0438L224.479 1.00168H226.646L217.042 13.2753L227 26.0499H224.792L215.897 14.5068L207.043 26.0499H204.856H204.898Z",
    fill: "#141414"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarrotRx);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/carrot-rx.974acf8a709bd4735fee08fc1fce8309.svg";